/* unplugin-vue-components disabled */import script from "./majorBack.vue?vue&type=script&setup=true&lang=js"
export * from "./majorBack.vue?vue&type=script&setup=true&lang=js"

import "./majorBack.vue?vue&type=style&index=0&id=848fd732&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-848fd732"]])

export default __exports__